module.exports = __webpack_public_path__ + "img/PDF.cb74375e.png";